export default {
      id: "video-event_smoking-usage",
      viewBox: "0 0 21 17",
      url: __webpack_public_path__ + "img/icons.svg#video-event_smoking",
      toString: function () {
        return this.url;
      }
    }